import {CountryOverviewRow} from './_models'

export type OverviewCacheState = {
  appliedYearFrom: number
  appliedYearTo: number
  countries: CountryOverviewRow[]
  years: number[]
}

// Module-level (not React state) on purpose: it needs to survive
// TradeDataManagementV2Page unmounting when the user clicks into a
// country/HS detail page and then hits the browser Back button. Plain
// react-router navigation fully unmounts the page, so without this, Back
// would remount the page fresh and re-queue the whole Comtrade scan just to
// show data that hasn't changed — slow and unnecessary.
//
// This only lives for the current SPA session (resets on a hard refresh),
// which is fine: Apply / "Check update" / a hard reload all re-fetch anyway.
let cache: OverviewCacheState | null = null

export function getOverviewCache(): OverviewCacheState | null {
  return cache
}

export function setOverviewCache(state: OverviewCacheState) {
  cache = state
}
